
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  loginFormButton: {
    id: "LoginForm.button",
    defaultMessage: "Login",
  }, 
});

export default MESSAGES;